import axios from 'axios'

class RolesHelper {
  rolesCache = null

  async getUserRole () {
    const AUTH_SESSION_KEY = 'infotourist_core_user'
    try {
      const userInfo = sessionStorage.getItem(AUTH_SESSION_KEY)
      if (!userInfo) throw new Error('User not found in session storage.')

      // Cache roles to avoid redundant API calls
      if (!this.rolesCache) {
        const response = await axios.get('/roles/')
        this.rolesCache = response.data?.data || []
      }
      const parsedUser = JSON.parse(userInfo)
      if (!parsedUser?.role) throw new Error('User role not found.')
      // if (!parsedUser?.role) return this.rolesCache.find(item => item.rol === 'Administrador') //! para probar usuarios sin rol

      const userRole = this.rolesCache.find(item => item.id === parsedUser.role)
      if (!userRole) throw new Error('Role not found in roles list.')

      return userRole
    } catch (error) {
      console.error('Error fetching user role:', error.message)
      return null
    }
  }

  async hasPermission (module, action) {
    try {
      const role = await this.getUserRole()
      if (!role) return false

      if (role.rol === 'Admin' && role.editable === false) return true

      const permissions = role.permissions || []
      const modulePermissions = permissions.find(item => item.module === module)

      return modulePermissions?.[action] === true || false
    } catch (error) {
      console.error('Error checking permissions:', error.message)
      return false
    }
  }
}

export { RolesHelper }
